import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../../../styles/colorVariables';

export const useStyles = makeStyles(() =>
  createStyles({
    root: {
      display: 'flex',
    },
    toastContent: {
      position: 'relative',
    },
    closeBtn: {
      position: 'absolute',
      top: -8,
      right: -8,
      fontSize: 18,
    },
    toastTitle: {
      fontSize: 14,
      fontWeight: 700,
      color: colorVariables.white,
      marginBottom: 6,
      paddingRight: 10,
      fontFamily: '"Open Sans", sans-serif',
    },
    iconWrap: {
      width: 28,
      height: 28,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      borderRadius: '50%',
      marginRight: 15,
      marginLeft: 4,
      transform: 'rotate(180deg)',
    },
    iconWrapSuccess: {
      backgroundColor: colorVariables.green,
    },
    iconWrapError: {
      backgroundColor: '#EA6363',
    },
    iconWrapWarning: {
      backgroundColor: '#FFD54F',
    },
    iconWrapInfo: {
      backgroundColor: '#33A8E2',
    },
    icon: {
      color: colorVariables.navy,
      fontSize: 20,
    },
    toastText: {
      color: colorVariables.grey60,
      lineHeight: '22px',
      fontFamily: '"Open Sans", sans-serif',
    },
    border: {
      position: 'absolute',
      width: 4,
      top: 0,
      bottom: 0,
      left: 0,
    },
    borderSuccess: {
      backgroundColor: colorVariables.green,
    },
    borderError: {
      backgroundColor: '#EA6363',
    },
    borderWarning: {
      backgroundColor: '#FFD54F',
    },
    borderInfo: {
      backgroundColor: '#33A8E2',
    },
    iconRotated: {
      transform: 'rotate(180deg)',
    },
    supplierBtn: {
      marginTop: 11,
      height: 28,
      width: 140,
      padding: 0,
      fontSize: 14,
      minWidth: 100,
    },
    turnOffBtn: {
      color: colorVariables.grey60,
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: colorVariables.grey60,
      position: 'absolute',
      right: 20,
      bottom: 6,
      cursor: 'pointer',
      '&:hover': {
        color: colorVariables.grey40,
        borderBottomColor: colorVariables.grey40,
      }
    }
  }),
);
